import z from "zod";
import { baseEntitySchema } from "./base";

export const BlockedContactDataSchema = z.object({
  // Normalized blocklist key (see normalizeBlocklistEmail). Kept as a field as
  // well as the document ID so the collection is readable in the console.
  email: z.string().min(1),
  // Free-text note for whoever added the block, e.g. "fraudulent submissions".
  reason: z.string().optional(),
  // Who added the block, e.g. an ops user email.
  blockedBy: z.string().optional(),
});

export type BlockedContactData = z.infer<typeof BlockedContactDataSchema>;
export const blockedContactSchema = baseEntitySchema.extend(
  BlockedContactDataSchema.shape,
);
export type BlockedContact = z.infer<typeof blockedContactSchema>;
